export default __webpack_public_path__ + "static/media/qualcomm.97a7dc20.svg";